import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import FloatingShapes from "@/components/FloatingShapes";
import Nav from "@/components/Nav";
import AuthSeoContent from "@/components/AuthSeoContent";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const googleLogin = () => {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await login(email, password); nav("/dashboard"); toast.success("Welcome back."); }
    catch (err) { toast.error(err?.response?.data?.detail || "Login failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="relative min-h-screen grain" data-testid="login-page">
      <FloatingShapes /><Nav />
      <main className="relative z-10 max-w-md mx-auto px-6 pt-32 pb-20">
        <h1 className="font-display text-5xl text-center">Welcome back</h1>
        <p className="font-hand text-stone-500 text-2xl text-center mt-2">pick up where you stopped</p>
        <form onSubmit={onSubmit} className="sticky-card p-8 mt-10 space-y-4" data-testid="login-form">
          <div>
            <label className="text-xs uppercase tracking-[0.18em] text-stone-500">Email</label>
            <input type="email" required value={email} onChange={e=>setEmail(e.target.value)}
                   className="input mt-2" data-testid="login-email-input" placeholder="you@page.com"/>
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.18em] text-stone-500">Password</label>
            <input type="password" required value={password} onChange={e=>setPassword(e.target.value)}
                   className="input mt-2" data-testid="login-password-input" placeholder="••••••••"/>
          </div>
          <button type="submit" disabled={busy} className="btn-primary w-full mt-2" data-testid="login-submit-button">
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-center">
            <Link to="/forgot-password" className="text-sm text-stone-500 hover:text-indigo-600 underline-offset-4 hover:underline" data-testid="forgot-password-link">
              Forgot your password?
            </Link>
          </div>
        </form>
        <div className="flex items-center gap-3 my-6">
          <div className="h-px bg-stone-300 flex-1"/>
          <span className="text-xs uppercase tracking-[0.2em] text-stone-500">or</span>
          <div className="h-px bg-stone-300 flex-1"/>
        </div>
        <button onClick={googleLogin} className="btn-ghost w-full flex items-center justify-center gap-3" data-testid="google-login-button">
          <svg viewBox="0 0 24 24" className="w-5 h-5"><path fill="#4285F4" d="M22.6 12.2c0-.8-.1-1.6-.2-2.4H12v4.5h6c-.3 1.4-1.1 2.6-2.3 3.4v2.8h3.7c2.2-2 3.4-5 3.4-8.3z"/><path fill="#34A853" d="M12 23c3.1 0 5.6-1 7.5-2.8l-3.7-2.8c-1 .7-2.3 1.1-3.8 1.1-2.9 0-5.4-2-6.3-4.6H1.9v2.9C3.8 20.5 7.6 23 12 23z"/><path fill="#FBBC05" d="M5.7 13.9c-.2-.6-.3-1.3-.3-2s.1-1.4.3-2V7H1.9C1.2 8.5.8 10.2.8 12s.4 3.5 1.1 5l3.8-3.1z"/><path fill="#EA4335" d="M12 5.4c1.7 0 3.2.6 4.4 1.7l3.3-3.3C17.6 1.9 15 1 12 1 7.6 1 3.8 3.5 1.9 7l3.8 2.9C6.6 7.4 9.1 5.4 12 5.4z"/></svg>
          Continue with Google
        </button>
        <p className="text-center text-stone-600 mt-8">
          New here? <Link to="/register" className="text-indigo-600 underline-offset-4 hover:underline" data-testid="login-to-register-link">Make a deck</Link>
        </p>
        <AuthSeoContent variant="login" />
      </main>
    </div>
  );
}
